import { NavLink } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  return (
    <nav className="Nav">
      <NavLink to="/">
        <img src="/Assets/Logo.png" alt="" className="Logo" />
      </NavLink>
      <div className="Nav-menu">
        <NavLink to="/portfolio" className="Nav-link">
          Portfolio
        </NavLink>
        <NavLink to="/about" className="Nav-link">
          About
        </NavLink>
        <NavLink to="/contact" className="Nav-link">
          Contact
        </NavLink>
      </div>
      <button
        className="Nav-btn"
        onClick={() =>
          (window.location.href = "mailto:shoqibulatzmi@gmail.com")
        }
      >
        Hire Me!
      </button>
    </nav>
  );
};

export default Navbar;
